/* Diamond Studio — mobile CRO layer (2026-09-29)
   Product page:
   1. Phones: the product's own label, title and price are MOVED above a shorter
      photo gallery (not copied, so nothing shows twice). On wider screens they
      go back to their original place in the buy box.
   2. Pre-selects 14K White gold when no gold colour is chosen yet (no extra cost).
   3. Photo viewer: tap the photo to zoom in, tap again to fit. */
(function () {
  'use strict';
  if (window.__dsCroMobile) return;
  window.__dsCroMobile = true;

  var body = document.body;
  if (!body || !body.classList.contains('signature-product-page')) return;

  var PHONE = '(max-width: 749px)';

  function waitFor(test, done, timeoutMs) {
    var start = Date.now();
    (function tick() {
      var result = null;
      try { result = test(); } catch (e) { result = null; }
      if (result) { done(result); return; }
      if (Date.now() - start > (timeoutMs || 15000)) return;
      setTimeout(tick, 150);
    })();
  }

  /* ---------- 1. Label + title + price above the gallery on phones ---------- */
  function setupSummary() {
    waitFor(function () {
      var media = document.querySelector('#product .a-product-media');
      var buyBox = document.getElementById('configure');
      if (!media || !buyBox) return null;
      var parts = [
        buyBox.querySelector('.a-product-label'),
        buyBox.querySelector('.ds-product-title'),
        buyBox.querySelector('.a-price-row')
      ].filter(Boolean);
      // Need at least the title and the price.
      if (!buyBox.querySelector('.ds-product-title') || !buyBox.querySelector('.a-price-row')) return null;
      return { media: media, parts: parts };
    }, function (el) {
      if (document.getElementById('ds-m-summary')) return;

      var box = document.createElement('div');
      box.id = 'ds-m-summary';
      box.className = 'ds-m-summary';
      el.media.parentNode.insertBefore(box, el.media);

      // Leave an invisible marker where each element lives so it can go back.
      var slots = el.parts.map(function (node) {
        var marker = document.createComment('ds-m-summary-slot');
        node.parentNode.insertBefore(marker, node);
        return { node: node, marker: marker };
      });

      function moveUp() {
        slots.forEach(function (s) {
          if (s.node.parentNode !== box) box.appendChild(s.node);
        });
        body.classList.add('ds-m-summary-on');
      }

      function moveBack() {
        slots.forEach(function (s) {
          if (s.marker.parentNode && s.node.previousSibling !== s.marker) {
            s.marker.parentNode.insertBefore(s.node, s.marker.nextSibling);
          }
        });
        body.classList.remove('ds-m-summary-on');
      }

      var mq = window.matchMedia ? window.matchMedia(PHONE) : null;
      function apply() { if (mq && mq.matches) moveUp(); else moveBack(); }
      apply();
      if (mq) {
        if (mq.addEventListener) mq.addEventListener('change', apply);
        else if (mq.addListener) mq.addListener(apply);
      }
    });
  }

  /* ---------- 2. Pre-select 14K White gold ---------- */
  function preselectMetal() {
    waitFor(function () {
      var inputs = document.querySelectorAll('section.a-metal input[type="radio"]');
      return inputs.length ? inputs : null;
    }, function (inputs) {
      // A gold chosen on a collection card arrives as ?gold=18K%20Yellow; otherwise default to 14K White.
      var wanted = '';
      try { wanted = (new URLSearchParams(location.search).get('gold') || '').trim().toLowerCase(); } catch (e) { wanted = ''; }
      var checked = null;
      for (var i = 0; i < inputs.length; i++) if (inputs[i].checked) checked = inputs[i];
      if (checked && (!wanted || String(checked.value).trim().toLowerCase() === wanted)) return;
      var find = function (value) {
        for (var j = 0; j < inputs.length; j++) {
          if (String(inputs[j].value).trim().toLowerCase() === value) return inputs[j];
        }
        return null;
      };
      var target = (wanted && find(wanted)) || (checked ? null : find('14k white'));
      if (!target) return;
      var label = target.id ? document.querySelector('label[for="' + target.id + '"]') : null;
      if (label) label.click(); else target.click();
      if (!target.checked) {
        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }, 12000);
  }

  /* ---------- 3. Tap the photo to zoom (uses the viewer's own "Zoom in" button) ---------- */
  function setupZoom() {
    document.addEventListener('click', function (event) {
      var img = event.target && event.target.closest ? event.target.closest('.ds-lightbox-stage img') : null;
      if (!img) return;
      var dialog = img.closest('dialog, [role="dialog"]') || document;
      var zoomBtn = dialog.querySelector('[data-pdp-action="zoom"]');
      if (!zoomBtn) return;

      var rect = img.getBoundingClientRect();
      var rx = rect.width ? (event.clientX - rect.left) / rect.width : 0.5;
      var ry = rect.height ? (event.clientY - rect.top) / rect.height : 0.5;
      var wasZoomed = img.classList.contains('ds-zoomed');

      zoomBtn.click();

      if (wasZoomed) return;
      // Centre the zoomed photo on the spot that was tapped.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var stage = dialog.querySelector('.ds-lightbox-stage');
          var zoomed = stage && stage.querySelector('img.ds-zoomed');
          if (!zoomed) return;
          stage.scrollLeft = Math.max(0, rx * zoomed.offsetWidth - stage.clientWidth / 2);
          stage.scrollTop = Math.max(0, ry * zoomed.offsetHeight - stage.clientHeight / 2);
        });
      });
    });
  }

  function init() {
    setupSummary();
    preselectMetal();
    setupZoom();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
